var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "el-form",
        {
          ref: "pram",
          attrs: { model: _vm.pram, "label-width": "100px" },
          nativeOn: {
            submit: function ($event) {
              $event.preventDefault()
            },
          },
        },
        [
          _c(
            "el-form-item",
            {
              attrs: {
                label: "角色名称",
                prop: "roleName",
                rules: _vm.roleNameRules,
              },
            },
            [
              _c("el-input", {
                attrs: { placeholder: "身份名称" },
                model: {
                  value: _vm.pram.roleName,
                  callback: function ($$v) {
                    _vm.$set(_vm.pram, "roleName", $$v)
                  },
                  expression: "pram.roleName",
                },
              }),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "el-form-item",
            { attrs: { label: "状态" } },
            [
              _c("el-switch", {
                attrs: { "active-value": true, "inactive-value": false },
                model: {
                  value: _vm.pram.status,
                  callback: function ($$v) {
                    _vm.$set(_vm.pram, "status", $$v)
                  },
                  expression: "pram.status",
                },
              }),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "el-form-item",
            { attrs: { label: "菜单权限" } },
            [
              _c(
                "el-checkbox",
                {
                  on: { change: _vm.handleCheckedTreeExpand },
                  model: {
                    value: _vm.menuExpand,
                    callback: function ($$v) {
                      _vm.menuExpand = $$v
                    },
                    expression: "menuExpand",
                  },
                },
                [_vm._v("展开/折叠")]
              ),
              _vm._v(" "),
              _c("el-tree", {
                ref: "menu",
                staticClass: "tree-border",
                attrs: {
                  data: _vm.menuOptions,
                  "show-checkbox": "",
                  "node-key": "id",
                  "check-strictly": _vm.checkStrictly,
                  "empty-text": "加载中，请稍候",
                  props: _vm.defaultProps,
                },
                on: {
                  "check-change": _vm.handleCheckChange,
                  "node-click": _vm.handleNodeClick,
                  "node-expand": _vm.handleNodeExpand,
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (ref) {
                      var node = ref.node
                      var data = ref.data
                      return _c(
                        "span",
                        { staticClass: "custom-tree-node" },
                        [
                          _c(
                            "span",
                            {
                              class: {
                                "disabled-tree-node": _vm.isProtected(data),
                              },
                            },
                            [
                              _vm._v(
                                "\n            " +
                                  _vm._s(node.label) +
                                  "\n          "
                              ),
                            ]
                          ),
                          _vm._v(" "),
                          _vm.isProtected(data)
                            ? _c(
                                "el-tooltip",
                                {
                                  attrs: {
                                    content: "系统必选运营权限，不可修改或取消",
                                    placement: "right",
                                    enterable: false,
                                  },
                                },
                                [
                                  _c("i", {
                                    staticClass:
                                      "el-icon-lock disabled-lock-icon",
                                  }),
                                ]
                              )
                            : _vm._e(),
                        ],
                        1
                      )
                    },
                  },
                ]),
              }),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "el-form-item",
            [
              _c(
                "el-button",
                {
                  directives: [
                    {
                      name: "hasPermi",
                      rawName: "v-hasPermi",
                      value: [
                        "admin:system:role:update",
                        "admin:system:role:save",
                      ],
                      expression:
                        "['admin:system:role:update','admin:system:role:save']",
                    },
                  ],
                  attrs: { type: "primary" },
                  on: {
                    click: function ($event) {
                      return _vm.handlerSubmit("pram")
                    },
                  },
                },
                [_vm._v(_vm._s(_vm.isCreate === 0 ? "确定" : "更新"))]
              ),
              _vm._v(" "),
              _c("el-button", { on: { click: _vm.close } }, [_vm._v("取消")]),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }